// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 创建因子回测 POST /multiple-factor/backtest/create */
export async function multipleFactorBacktestCreateUsingPOST(
  body: API.MultipleFactorBacktestCreateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/multiple-factor/backtest/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除多因子回测 POST /multiple-factor/backtest/delete */
export async function multipleFactorBacktestDeleteUsingPOST(
  body: API.DeleteMultipleFactorBacktestReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/multiple-factor/backtest/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 多因子回测委托列表 GET /multiple-factor/backtest/entrust-list */
export async function multipleFactorBacktestEntrustListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestEntrustListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorBacktestEntrustResp>(
    '/multiple-factor/backtest/entrust-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子回测详情 GET /multiple-factor/backtest/info */
export async function multipleFactorBacktestInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMultipleFactorBacktestInfoResp>('/multiple-factor/backtest/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 多因子回测列表 GET /multiple-factor/backtest/list */
export async function multipleFactorBacktestListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorBacktestSimpleResp>(
    '/multiple-factor/backtest/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子回测持仓列表 GET /multiple-factor/backtest/position-list */
export async function multipleFactorBacktestPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorBacktestPositionResp>(
    '/multiple-factor/backtest/position-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 查询多因子回测历史持仓 GET /multiple-factor/backtest/position-settlement-list */
export async function multipleFactorBacktestPositionSettlementListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestPositionSettlementListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorBacktestPositionSettlementResp>(
    '/multiple-factor/backtest/position-settlement-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子回测收益列表 GET /multiple-factor/backtest/profit-list */
export async function multipleFactorBacktestProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorBacktestProfitResp>(
    '/multiple-factor/backtest/profit-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 查询多因子回测收益详情 GET /multiple-factor/backtest/profit-statistics-info */
export async function multipleFactorBacktestProfitStatisticsInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestProfitStatisticsInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMultipleFactorBacktestProfitStatisticsInfoResp>(
    '/multiple-factor/backtest/profit-statistics-info',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子回测收益统计列表 GET /multiple-factor/backtest/profit-statistics-list */
export async function multipleFactorBacktestProfitStatisticsListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestProfitStatisticsListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorBacktestProfitStatisticsResp>(
    '/multiple-factor/backtest/profit-statistics-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子回测每日选股记录 GET /multiple-factor/backtest/selection-stock/list */
export async function multipleFactorBacktestSelectionStockListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorBacktestSelectionStockListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorSelectionStockResp>(
    '/multiple-factor/backtest/selection-stock/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取因子分类树状结构 GET /multiple-factor/group/tree */
export async function multipleFactorGroupTreeUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListMultipleFactorGroupTreeResp>('/multiple-factor/group/tree', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 多因子模拟交易委托列表 GET /multiple-factor/mock/entrust-list */
export async function multipleFactorMockEntrustListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockEntrustListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorMockEntrustResp>(
    '/multiple-factor/mock/entrust-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易详情 GET /multiple-factor/mock/info */
export async function multipleFactorMockInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMultipleFactorMockInfoResp>('/multiple-factor/mock/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 多因子模拟交易订阅/取消调仓通知 POST /multiple-factor/mock/notice-subscribe */
export async function multipleFactorMockNoticeSubscribeUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockNoticeSubscribeUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/multiple-factor/mock/notice-subscribe', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 多因子模拟交易计划-交易计划详情列表 GET /multiple-factor/mock/plan/detail/list */
export async function multipleFactorMockPlanDetailListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPlanDetailListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyMockPlanDealResp>(
    '/multiple-factor/mock/plan/detail/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易计划-委托列表 GET /multiple-factor/mock/plan/entrust/list */
export async function multipleFactorMockPlanEntrustListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPlanEntrustListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorMockPlanEntrustResp>(
    '/multiple-factor/mock/plan/entrust/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易计划列表 GET /multiple-factor/mock/plan/list */
export async function multipleFactorMockPlanListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPlanListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorMockPlanResp>('/multiple-factor/mock/plan/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 多因子模拟交易计划-持仓列表 GET /multiple-factor/mock/plan/position/list */
export async function multipleFactorMockPlanPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPlanPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorMockPlanPositionResp>(
    '/multiple-factor/mock/plan/position/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易计划-目标选股 GET /multiple-factor/mock/plan/selection-stock/list */
export async function multipleFactorMockPlanSelectionStockListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPlanSelectionStockListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMultipleFactorMockPlanSelectionStockResp>(
    '/multiple-factor/mock/plan/selection-stock/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易计划-目标持仓列表 GET /multiple-factor/mock/plan/target-position/list */
export async function multipleFactorMockPlanTargetPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPlanTargetPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorMockPlanTargetPositionResp>(
    '/multiple-factor/mock/plan/target-position/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易持仓列表 GET /multiple-factor/mock/position-list */
export async function multipleFactorMockPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorMockPositionResp>(
    '/multiple-factor/mock/position-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易历史持仓 GET /multiple-factor/mock/position-settlement-list */
export async function multipleFactorMockPositionSettlementListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockPositionSettlementListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorMockPositionSettlementResp>(
    '/multiple-factor/mock/position-settlement-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易收益列表 GET /multiple-factor/mock/profit-list */
export async function multipleFactorMockProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorMockProfitResp>(
    '/multiple-factor/mock/profit-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易收益 GET /multiple-factor/mock/profit-statistics-info */
export async function multipleFactorMockProfitStatisticsInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockProfitStatisticsInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMultipleFactorMockProfitStatisticsInfoResp>(
    '/multiple-factor/mock/profit-statistics-info',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易收益统计列表 GET /multiple-factor/mock/profit-statistics-list */
export async function multipleFactorMockProfitStatisticsListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockProfitStatisticsListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorMockProfitStatisticsResp>(
    '/multiple-factor/mock/profit-statistics-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易每日选股记录 GET /multiple-factor/mock/selection-stock/list */
export async function multipleFactorMockSelectionStockListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockSelectionStockListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorSelectionStockResp>(
    '/multiple-factor/mock/selection-stock/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子模拟交易除权除息记录查询 GET /multiple-factor/mock/xrd-record/list */
export async function multipleFactorMockXrdRecordListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorMockXrdRecordListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorMockXrdRecordResp>(
    '/multiple-factor/mock/xrd-record/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子择时模板列表 GET /multiple-factor/position-template/list */
export async function multipleFactorPositionTemplateListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorPositionTemplateListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMultipleFactorPositionTemplateInfoResp>(
    '/multiple-factor/position-template/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子条件选股 POST /multiple-factor/stock/list */
export async function multipleFactorStockListUsingPOST(
  body: API.MultipleFactorStockReq,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorStockResp>('/multiple-factor/stock/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建多因子策略 POST /multiple-factor/strategy/create */
export async function multipleFactorStrategyCreateUsingPOST(
  body: API.CreateMultipleFactorStrategyReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/multiple-factor/strategy/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除多因子策略 POST /multiple-factor/strategy/delete */
export async function multipleFactorStrategyDeleteUsingPOST(
  body: API.DeleteMultipleFactorStrategyReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/multiple-factor/strategy/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 多因子策略列表 GET /multiple-factor/strategy/list */
export async function multipleFactorStrategyListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.multipleFactorStrategyListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMultipleFactorStrategyInfoResp>(
    '/multiple-factor/strategy/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 多因子权重排序条件前端列表 GET /multiple-factor/weight-condition/list */
export async function multipleFactorWeightConditionListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListRaMultipleFactorWeightConditionResp>(
    '/multiple-factor/weight-condition/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
